import {BrandBase} from '../BrandBase';
import {createMicrositeTheme} from '../MicrositeTheme';

export const chatiwiBase: BrandBase = {
  id: `chatiwi`,
  domain: `chatiwi.com`,
  email: `support@chatiwi.com`,
  theme: `chatiwi`,
  backgroundId: `elegant`,
  adsenseId: `ca-pub-7484826203790515`,
  micrositeTheme: createMicrositeTheme({
    id: `chatiwi`,
    name: `Chatiwi Microsite`,
    palette: {
      primary: `#9E77ED`,
      secondary: `#FF7EB6`,
      accent: `#F6C76F`,
    },
    text: {
      base: `#1A0B2E`,
      muted: `#5B436F`,
      onLight: `#1A0B2E`,
      mutedOnLight: `rgba(26, 11, 46, 0.7)`,
      onDark: `#FFF6FF`,
      mutedOnDark: `rgba(255, 236, 252, 0.82)`,
    },
    backgrounds: {
      page: `linear-gradient(180deg, #050510 0%, #16072C 40%, #FFF4FB 100%)`,
      surface: `#ffffff`,
      surfaceAlt: `#FFF7FD`,
      light: `#FFF2FB`,
      dark: `#070212`,
    },
    gradients: {
      hero: `linear-gradient(135deg, #271149 0%, #7A1F70 45%, #FF7EB6 100%)`,
      sectionLight: `linear-gradient(135deg, rgba(255, 247, 254, 0.98), rgba(244, 244, 255, 0.95))`,
      sectionDark: `linear-gradient(150deg, #09031A, #1C0930 50%, #321237 100%)`,
      primaryCta: `linear-gradient(120deg, #FF7EB6 0%, #B388FF 45%, #F6C76F 100%)`,
    },
    sections: {
      light: {
        background: `rgba(255, 255, 255, 0.97)`,
        patternColor: `#FFF2FA`,
        cardBackground: `rgba(255, 255, 255, 0.95)`,
        cardBorder: `rgba(210, 180, 216, 0.45)`,
      },
      dark: {
        background: `rgba(8, 3, 22, 0.95)`,
        cardBackground: `rgba(255, 255, 255, 0.12)`,
        cardBorder: `rgba(255, 255, 255, 0.2)`,
      },
    },
    ctas: {
      primary: {
        background: `linear-gradient(120deg, #FF7EB6 0%, #B388FF 45%, #F6C76F 100%)`,
        glow: `rgba(255, 126, 182, 0.45)`,
        shadow: `0 32px 70px rgba(255, 126, 182, 0.35)`,
        highlight: `rgba(255, 248, 254, 0.6)`,
        text: `#1A0B2E`,
      },
      secondary: {
        text: `#20142F`,
        hoverText: `#20142F`,
        underline: `rgba(32, 20, 47, 0.6)`,
        background: `transparent`,
        hoverBackground: `rgba(255, 255, 255, 0.95)`,
        shadow: `0 18px 34px rgba(25, 10, 35, 0.2)`,
      },
    },
    cards: {
      surface: `#ffffff`,
      border: `rgba(216, 191, 216, 0.5)`,
      darkSurface: `rgba(255, 255, 255, 0.12)`,
      darkBorder: `rgba(255, 255, 255, 0.25)`,
    },
  }),
  hostRedirects: {
    'www.chatiwi.com': `chatiwi.com`,
  },
  manifest: {
    name: `Chatiwi | Private Anonymous Chat Rooms - No Registration Required`,
    short_name: `Chatiwi`,
    description: `Chat privately on Chatiwi with anonymous chat rooms and one-to-one messaging. No registration, encryption-first, built for fast and safe conversations.`,
    theme_color: `#00BCD4`,
    background_color: `#ffffff`,
    display: `standalone`,
    orientation: `portrait`,
    scope: `/`,
    start_url: `/`,
    icons: [],
  },
  canonical: {
    prod: `https://chatiwi.com`,
    uat: `https://chatiwi.dev.t.hackhat.com`,
    local: `http://localhost:5173`,
    localdev: `http://localhost:5173`,
    localnative: `http://localhost:5173`,
  },
  favicon: `/logo-square.png`,
  seo: {
    keywords: `Chatiwi, anonymous chat app, private chat rooms, no registration chat, encrypted messaging, free chat, instant chat`,
    author: `Chatiwi`,
  },
  social: {
    title: `Chatiwi | Anonymous Chat Rooms Without Registration`,
    image: `/logo-square.png`,
  },
};
